import { z } from "zod";

export const LogicalOperators = {
  and: "$and",
  or: "$or",
  not: "$not",
} as const;
export const LogicalOperatorsSchema = z.nativeEnum(LogicalOperators);
export type LogicalOperatorsType = z.infer<typeof LogicalOperatorsSchema>;

export const ComparisonOperators = {
  exact: "$exact",
  like: "$like",
  in: "$in",
  all: "$all",
  gt: "$gt",
  gte: "$gte",
  lt: "$lt",
  lte: "$lte",
  eq: "$eq",
  ne: "$ne",
  exists: "$exists",
} as const;
export const ComparisonOperatorsSchema = z.nativeEnum(ComparisonOperators);
export type ComparisonOperatorsType = z.infer<typeof ComparisonOperatorsSchema>;
